module.exports = __webpack_public_path__ + "img/1586496444.04845def.jpg";